import { IP_RESTRICTED_APIS } from "constants/Apis/ipRestrictedApis.constants"

export const isApiIpRestricted = (url) => {
    const matchingPathIdx = IP_RESTRICTED_APIS.findIndex((_path) => {
        return url?.includes(_path)
    })
    return matchingPathIdx !== -1
}